var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gb-label-value-text"},[_c('span',{staticClass:"gb-label-text"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"gb-value-text",class:{
      'gn-value-textarea': _vm.isTextArea,
      'gb-value-ellipsis': _vm.isEllipsis
    },attrs:{"title":_vm.value}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }